<template>
  <a
    class="dashboard-promo-banner dashboard-promo-banner--timer"
    :href="$route.name === 'Dashboard' ? Urls['subscriptions:manage']() : null"
    :style="$route.name !== 'Dashboard' ? 'margin-left: 0px; margin-right: 0px; cursor: auto;' : ''"
    :class="{ open: isOpen }"
  >
    <div class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <div class="promo">
            <h1 class="promo-intro">
              <span v-translate>You have a free premium account</span>
            </h1>
            <span class="upgrade-free-message">
              {{
                $gettext(
                  'Your free premium trial is active. Upgrade now to keep premium features after your trial ends.'
                )
              }}
            </span>
          </div>
        </div>
        <div class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('The account will be downgraded at:') }}</span>
            <FlipCount :time-until="activePlan.end_date" />
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import FlipCount from '@/components/dashboard/ui/FlipCount'

export default {
  name: 'FreeMonthBanner',
  components: {
    FlipCount,
  },
  mounted() {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      activePlan: 'subscriptionStore/getActivePlan',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .dashboard-promo-banner--timer {
    background-image: linear-gradient(to right top, #545094, #505b9b, #4e65a2, #4d6fa7, #4f79ab, #4883b0, #438cb3, #4295b5, #39a0b4, #3faaaf, #50b3a7, #69bb9d);
  }
</style>

